"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlSelectDropdown", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./tlSelectDropdown.html"),
    require: ["tlSelectDropdown", "^tlSelect"],
    controllerAs: "$dropdown",
    link: function link($scope, $el, $attrs, controllers) {
      var dropdownCtrl = controllers[0],
        selectCtrl = controllers[1];
      selectCtrl.setDropdownCtrl(dropdownCtrl);
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        selectCtrl = $scope.$select;
      ctrl.getElement = function () {
        return $element;
      };
      ctrl.getActiveOptionIdx = function () {
        return selectCtrl.state.activeOptionIdx;
      };
      ctrl.showFooter = function () {
        var config = selectCtrl.getConfig();
        return config.expandButton != null;
      };
      ctrl.onExpandClick = function (event) {
        event.preventDefault();
        var config = selectCtrl.getConfig();
        config.expandButton.handler(selectCtrl);
      };
      console.log('ready');
    }
  };
});
ngModule.directive("tlSelectGroupLabel", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./tlSelectGroupLabel.html"),
    require: "^tlSelectDropdown",
    link: function link($scope, $el, $attrs, dropdownCtrl) {
      var groupLabelTranscludeFn = $scope.$select.getGroupLabelTranscludeFn(); // TODO : access from dropdown
      groupLabelTranscludeFn($scope, function (clone) {
        clone.appendTo($el);
        //                console.log("ajoute ",clone);
      });
    }
  };
});

/**
 * une ligne d'option
 */
ngModule.directive("tlSelectDropdownOption", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./tlSelectDropdownOption.html"),
    require: "^tlSelectDropdown",
    link: function link($scope, $el, $attrs, dropdownCtrl) {
      var option = $scope.option,
        optionIdx = $scope.optionIdx;

      // optimize watchers by using event to set active option.
      var onActiveChange = function onActiveChange() {
        if (dropdownCtrl.getActiveOptionIdx() === optionIdx) {
          $el.addClass("active");
        } else {
          $el.removeClass("active");
        }
      };
      $scope.$on("tl-select:active-change", onActiveChange);
      onActiveChange();

      // transclude option template or empty label template
      if (option.$empty) {
        $("<span>").addClass("empty-label").text(option.label).appendTo($el);
      } else {
        var optionTranscludeFn = $scope.$select.getOptionTranscludeFn(); // TODO : access from dropdown //selectCtrl.getOptionTranscludeFn();
        optionTranscludeFn($scope, function (clone) {
          clone.appendTo($el);
          $scope.loadingRenderDone = true;
        });
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/tlSelectDropdown.js
// module id = 2999
// module chunks = 13